/**
 * 教师业务接口（education-teacher）
 * Swagger: basePath=/teacher，paths=/teacher、/teacher/list、/teacher/{id}、/teacher/all
 * 网关完整前缀：/teacher/teacher
 */
import { get, post, put, del } from "../request";

export {
  teacherAuthLogin,
  teacherAuthInfo,
  teacherAuthLogout
} from "./auth";

const PREFIX = "/teacher/teacher";

/** 分页查询教师 GET /teacher/teacher/list */
export function getTeacherList(params) {
  return get(`${PREFIX}/list`, params);
}

/**
 * 按教师类型全量查询
 * GET /teacher/teacher/all?teacherType=
 * teacherType: 1负责人 2讲师
 */
export function getTeacherAll(teacherType) {
  return get(`${PREFIX}/all`, { teacherType });
}

/** 教师详情 GET /teacher/teacher/{teacherId} */
export function getTeacherDetail(teacherId) {
  return get(`${PREFIX}/${teacherId}`);
}

/** 新增教师 POST /teacher/teacher */
export function addTeacher(data) {
  return post(PREFIX, data);
}

/** 修改教师 PUT /teacher/teacher */
export function updateTeacher(data) {
  return put(PREFIX, data);
}

/** 删除教师 DELETE /teacher/teacher/{teacherId} */
export function deleteTeacher(teacherId) {
  return del(`${PREFIX}/${teacherId}`);
}



// WEBPACK FOOTER //
// ./src/api/teacher/index.js